import { createJoinPath } from '@sgcmpteltd/uikit-next/utils/url/join/public';

import {
  SGCM_MEDIA_ORIGIN,
  SGCM_MOBILE_SITE_ORIGIN,
  SGCM_MS_SITE_ORIGIN,
  SGCM_MYCARFORUM_ORIGIN,
  SGCM_SITE_ORIGIN,
} from '@/configs/public-url';

export const joinSgcmSite = createJoinPath(SGCM_SITE_ORIGIN ?? '');

export const joinSgcmMobileSite = createJoinPath(SGCM_MOBILE_SITE_ORIGIN ?? '');

export const joinSgcmMsSite = createJoinPath(SGCM_MS_SITE_ORIGIN ?? '');

export const joinSgcmMedia = createJoinPath(SGCM_MEDIA_ORIGIN ?? '');

export const joinMyCarForumSite = createJoinPath(SGCM_MYCARFORUM_ORIGIN ?? '');
